import ToastWrapper from "@common/helpers/toastWrapper";
import PaidTicketApi from "@common/services/paidTicketApi";

const ticketErrMap = {
  TerminalTicketAlreadyPaid: "Voucher is already exchanged",
  TerminalTicketNotFound: "Terminal ticket not found",
  BetNotFoundError: "Bet not found",
  alreadyPaid: "This ticket is already paid",
  "The bet is not found": "Bet not found",
  WrongInputParameters: "Wrong Barcode parameters",
  2099: "Wrong Barcode parameters",
  NotAuthorized: "Terminal ticket not found",
  InternalError: "Bet not found",
  "Client currency mismatch": "Bet not found",
  "Error processing your request": "Bet not found",
  PartnerMismatch: "Bet not found",
  "Not allowed": "The bet was placed in another location",
  NotAllowed: "The bet was placed in another location",
  2046: "The bet was placed in another location",
};

export const getPaidDate = (result) => result.Data?.[0]?.PaidCashDeskId || result.data?.paid_cashdesk_id;
// result.Data?.[0]?.PaidDate
// || result.data?.paid_date

const getErrorStatusCode = (result) => +result.StatusCode || result.code || result.status_code || result.StatusCode;

export const getErrorText = (result) => {
  const statusCode = getErrorStatusCode(result);
  if (getPaidDate(result) || (getPaidDate(result) && statusCode === 0)) return ticketErrMap.alreadyPaid;

  if (+statusCode === 0) return null;

  return ticketErrMap[result.data] || ticketErrMap[statusCode] || result.data;
};

export const getTicketError = (result) => {
  let error, errorText;

  if (!result) {
    return {
      error: true,
      errorText: "No response from server",
    };
  } else if (result.Error) {
    (error = true), (errorText = result.Error);
    // currency mismatch has different model of error
  } else {
    const statusCode = getErrorStatusCode(result);
    error = !!getPaidDate(result) || (!!statusCode && +statusCode !== 0);
    errorText = getErrorText(result);
  }

  return { error, errorText };
};

export const handleTicketError = async (data) => {
  const alreadyPaid = (
    data.dataFromSwarm?.PaidCashdeskId
    || data.dataFromSwarm?.PaidDate
    || data.dataFromSwarm?.paid_cashdesk_id
    || data.dataFromSwarm?.paid_date
  );

  if (!alreadyPaid) return;

  const betId = data.dataFromCasino?.CasinoTransactionId || data.dataFromSwarm?.id;

  if (!betId) return;

  try {
    await PaidTicketApi.markAsPaid({
      betId: betId.toString(),
      paidDate: (
        data.dataFromSwarm?.PaidDate || data.dataFromSwarm?.paid_date || new Date().toISOString()
      ),
    });
  } catch {
    console.log('Failed to mark ticket as paid in update board');
  }
};
